import { createStyles, makeStyles } from '@material-ui/core/styles';
import { GRAY, PRIMARY, BORDER_GRAY, SECONDARY, FLYTLIGHTGRAY } from 'constants/colors';
export default makeStyles(theme => createStyles({
  wrapper: {
    position: 'relative',
    width: 'fit-content'
  },
  link: {
    display: 'flex',
    textAlign: 'left',
    textDecoration: 'none',
    color: theme.palette.text.primary,
    fontWeight: 'bolder'
  },
  icon: {
    marginRight: theme.spacing(2),
    color: PRIMARY
  },
  primaryButton: {
    color: SECONDARY,
    fontWeight: 700,
    transition: '.1s',
    '&:first-child': {
      display: 'flex',
      alignItems: 'center'
    },
    '&:hover': {
      color: FLYTLIGHTGRAY,
      boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
      backgroundColor: SECONDARY
    }
  },
  secondaryButton: {
    position: 'relative',
    transition: '.1s',
    color: SECONDARY,
    borderColor: PRIMARY,
    fontWeight: 700,
    '&:first-child': {
      display: 'flex',
      alignItems: 'center'
    },
    '&:hover': {
      backgroundColor: PRIMARY,
      boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)'
    }
  },
  download: {
    display: 'flex',
    alignItems: 'center'
  },
  backButton: {
    display: 'flex',
    position: 'relative'
  },
  backButtonLink: {
    height: '100%',
    margin: 'auto 0',
    padding: theme.spacing(2),
    paddingLeft: 0,
    color: GRAY,
    display: 'flex',
    alignItems: 'center'
  },
  spacingRight: {
    marginRight: theme.spacing(2)
  },
  navLinkLabel: {
    color: 'inherit',
    fontSize: '1.1rem',
    textUnderlineOffset: '0.4rem'
  },
  fileInput: {
    display: 'none'
  },
  fileButton: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  linkButton: {
    fontWeight: 'bold'
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  addAddress: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    border: `1px solid ${BORDER_GRAY}`,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5)
  }
}));